"use client"
import { TextField, InputAdornment, IconButton, Typography } from "@mui/material"

function InputField2({
    label,
    register,
    type,
    icon,
    onClick,
    startIcon, // ✅ NEW
    onStartClick, // ✅ NEW optional handler for start icon
    fullWidth = true,
    placeholder,
    error,
    helperText,
    sx,
    ...props
}) {
    return (
        <div className="flex flex-col gap-2">
        {label && <label style={{ color: "#a3abb2", fontWeight: 600,fontFamily:"Maven Pro, sans-serif " }}>{label}</label>}

            <TextField
                type={type || "text"}
                placeholder={placeholder}
                fullWidth={fullWidth}
                variant="outlined"
                error={error}
                helperText={helperText}
                {...props}
                // ✅ Spread register props explicitly
                {...(register || {})}
                sx={{
                    mt: 1,
                    "& .MuiOutlinedInput-root": {
                        fontSize:'15px',
                        color:'#a3abb2',
                        backgroundColor: "rgba(51, 65, 85, 0.5)",
                        borderRadius: "8px",
                        "& fieldset": {
                            borderColor: "rgb(71, 85, 105)",
                        },
                        "&:hover fieldset": {
                            borderColor: "rgb(71, 85, 105)",
                        },
                        "&.Mui-focused fieldset": {
                            borderColor: "rgb(59, 130, 246)",
                            borderWidth: "2px",
                        },
                        "& input": {
                            color: "#a3abb2",
                               fontSize:'15px',
                            padding: "12px 16px",
                        },
                        "& input::placeholder": {
                            color: "rgb(156, 163, 175)",
                            opacity: 1,
                        },
                    },
                    ...sx,
                }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <IconButton
                                onClick={onStartClick}
                                edge="start"
                                sx={{
                                    color: "rgb(156, 163, 175)",
                                    fontSize:'15px',
                                    "&:hover": {
                                        color: "white",
                                    },
                                }}
                            >
                                {startIcon}
                            </IconButton>
                        </InputAdornment>
                    ),
                    endAdornment: icon && (
                        <InputAdornment position="end">
                            <IconButton
                                onClick={onClick}
                                edge="end"
                                sx={{
                                    color: "rgb(156, 163, 175)",
                                    "&:hover": {
                                        color: "white",
                                    },
                                }}
                            >
                                {icon}
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
            />
            <Typography color="error" sx={{ fontSize: 12, textAlign: "left", mt: 0.5 }}>
                {error}
            </Typography>
        </div>
    )
}

export default InputField2
